
    import { Component, Vue } from 'vue-property-decorator';
    import Tooltip from '@/components/configurator/Tooltip.vue';
    import InfoModal from '@/components/configurator/InfoModal.vue';
    import { buildDistancesText } from '@/util/misc';
    import i18n from '@/i18n';
    import { Country } from '@/enums/Country';
    import { useGlobalStore } from '@/store/global';
    import { useConfiguratorStore } from '@/store/configurator';

    @Component({
        components: {
            InfoModal,
            Tooltip,
        },
    })
    export default class KmChooser extends Vue {
        showModalInfo = false;
        deInfoContent = `
        <strong>${i18n.tc('messages.config.estimate_mileages')}</strong>
            <div>
                - ${i18n.tc('messages.config.mileages.few')}<br>
                - ${i18n.tc('messages.config.mileages.second')}<br>
                - ${i18n.tc('messages.config.mileages.average')}<br>
                - ${i18n.tc('messages.config.mileages.frequent')}<br>
                <p style="margin-top: 0.7rem;">${i18n.tc('messages.config.higher_mileages')}</p>
            </div>
    `;
        country: any;

        possible_kms = [5000, 10000, 15000, 20000, 25000, 30000, 35000];

        get globalStore() {
            return useGlobalStore();
        }

        get configuratorStore() {
            return useConfiguratorStore();
        }

        get infoContent() {
            return this.deInfoContent;
        }

        beforeCreate() {
            this.country = Country;
        }

        getDistancesText(distance: number) {
            return buildDistancesText(distance);
        }

        closeModal() {
            this.showModalInfo = false;
        }
    }
